module.exports = __webpack_public_path__ + "static/media/other.c17b0bf2.png";